<template>
    <products-provider
        v-slot="{
            campaign,
            proposal,
            proposalStep,
            loadedProducts,
            preselectedProducts,
            exitConfirmationRequired,
            loadCheckoutUrlProducts,
            patchProposalStep,
            goPreviousStep,
            goNextStep,
            isLoading,
            isLoadingCheckoutUrl,
            removeProduct,
            isCompletingProposal,
            errorMessage,
            errors,
            checkOutUrlErrorMessage,
            loadProductUrl
        }"
        style="height: 100%"
    >
        <proposal-products-view
            :campaign="campaign"
            :proposal="proposal"
            :proposal-step="proposalStep"
            :products="loadedProducts"
            :preselected-products="preselectedProducts"
            :is-loading="isLoading"
            :is-loading-checkout-url="isLoadingCheckoutUrl"
            :is-completing-proposal="isCompletingProposal"
            :error-message="errorMessage"
            :errors="errors"
            :check-out-url-error-message="checkOutUrlErrorMessage"
            :exit-confirmation-required="exitConfirmationRequired"
            @remove-product="removeProduct"
            @checkout-products="loadCheckoutUrlProducts"
            @load-product-url="loadProductUrl"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchProposalStep"
        />
    </products-provider>
</template>

<script>
    import ProposalProductsView from '../data-views/proposals/ProposalProductsView';
    import ProductsProvider from '../providers/proposal-steps/ProductsProvider';

    export default {
        name: 'ProposalProductsRouterView',
        components: {
            ProductsProvider,
            ProposalProductsView
        }
    };
</script>
